import { ApolloQueryResult, useQuery } from '@apollo/client';
import { useContext } from 'react';

import { isDemoEnvironment } from '../../../../constants/global';
import { GlobalPermissionsContext } from '../../../../context';
import { handleGql403 } from '../../../../utils';
import { GetUnreadNotificationsCountByUserQuery, GetUnreadNotificationsCountByUserQueryVariables } from '../../types';
import { mockNotificationsByUser } from '../useGetNotificationsByUser/mock';
import { GET_UNREAD_NOTIFICATIONS_COUNT_BY_USER } from './getBellNotificationStatus';

export type UseGetBellNotificationStatus = {
  total: number;
  loading: boolean;
  refetch(): Promise<ApolloQueryResult<GetUnreadNotificationsCountByUserQuery>>;
};

const useGetBellNotificationStatus = (userId: string, pollInterval: number): UseGetBellNotificationStatus => {
  const { READ_NOTIFICATION } = useContext(GlobalPermissionsContext).permissions;
  const { data, loading, refetch } = useQuery<
    GetUnreadNotificationsCountByUserQuery,
    GetUnreadNotificationsCountByUserQueryVariables
  >(GET_UNREAD_NOTIFICATIONS_COUNT_BY_USER, {
    variables: {
      userId,
    },
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'network-only',
    onError: handleGql403,
    skip: isDemoEnvironment || !userId || !READ_NOTIFICATION,
    pollInterval,
  });

  if (isDemoEnvironment) {
    return {
      total: mockNotificationsByUser.length,
      loading: false,
      refetch: () => Promise.resolve({} as ApolloQueryResult<GetUnreadNotificationsCountByUserQuery>),
    };
  }

  return { total: data?.getNotificationsByUser?.total || 0, loading: loading, refetch };
};

export default useGetBellNotificationStatus;
